var map = {
	"./accounts/api/checkRefundStatus.graphql": "7166",
	"./accounts/api/getAllCreditNoteTransaction.graphql": "6da5",
	"./accounts/api/getAllInvoiceTransaction.graphql": "840a",
	"./accounts/api/getAllOnlineRefund.graphql": "5619",
	"./accounts/api/getAppConfigurations.graphql": "cf71",
	"./accounts/api/getAppConfigurationsPC.graphql": "5da3",
	"./accounts/api/getCustomerAddressForInvoice.graphql": "27fd",
	"./accounts/api/getInvoiceById.graphql": "a33b",
	"./accounts/api/markAsRefunded.graphql": "bc99",
	"./accounts/api/updateConfigurations.graphql": "0ffe",
	"./accounts/api/updateConfigurationsPC.graphql": "7682",
	"./admins/api/createAdmin.graphql": "f951",
	"./admins/api/deleteAdmin.graphql": "e508",
	"./admins/api/getAllAdmins.graphql": "3e0c",
	"./admins/api/updateAdmin.graphql": "c246",
	"./api-user/api/createAPIUser.graphql": "929e",
	"./api-user/api/deleteAPIUser.graphql": "25bc",
	"./api-user/api/getAllAPIUsers.graphql": "0ea6",
	"./appointments/api/getAllActiveAppoinments.graphql": "afca",
	"./appointments/api/getAllActiveAppoinmentsByUserID.graphql": "a9b7",
	"./appointments/api/getAllAppoinments.graphql": "cf44",
	"./appointments/api/getAllClosedAppoinments.graphql": "8a05",
	"./appointments/api/updateAppointment.graphql": "a0d1",
	"./article/api/createArticle.graphql": "1840",
	"./article/api/deleteArticle.graphql": "bd00",
	"./article/api/getArticle.graphql": "31f4",
	"./article/api/updateArticle.graphql": "605d1",
	"./audit-trial-log/api/getAllAuditTrialByAuditType.graphql": "d4a2",
	"./audit-trial-log/api/getAllPlanSwitchErrors.graphql": "de19",
	"./audit-trial-log/api/updateAuditTrial.graphql": "4fca",
	"./bills-and-payments/api/getPlanUsage.graphql": "4e9b",
	"./bills-and-payments/api/getSaasBillPayments.graphql": "c0a2",
	"./bills-and-payments/api/getSaasBillRefunds.graphql": "b06e",
	"./bills-and-payments/api/printSaasBillInvoice.graphql": "c926",
	"./branch/api/createBranch.graphql": "b25b",
	"./branch/api/deleteBranch.graphql": "6f474",
	"./branch/api/getAllBranches.graphql": "9e31",
	"./branch/api/getAllBranchesForDropdown.graphql": "bd0b",
	"./branch/api/getBranch.graphql": "102d",
	"./branch/api/updateBranch.graphql": "115c",
	"./celebrity/api/addReferralTransaction.graphql": "9440",
	"./celebrity/api/assignPackageToCelebrity.graphql": "d6c3",
	"./celebrity/api/createCelebrity.graphql": "0094",
	"./celebrity/api/deleteCelebrity.graphql": "8930",
	"./celebrity/api/getAllCelebrity.graphql": "45f4",
	"./celebrity/api/getAllCelebrityPackages.graphql": "c79b",
	"./celebrity/api/getAllReferralTransactionsByUser.graphql": "391a",
	"./celebrity/api/getCelebrityById.graphql": "5ba4",
	"./celebrity/api/removePackageFromCelebrity.graphql": "6234",
	"./celebrity/api/totalReferralTransactionAmountByUser.graphql": "ba82",
	"./celebrity/api/updateCelebrity.graphql": "6cc3",
	"./contact-method/api/createContactMethod.graphql": "03fd",
	"./contact-method/api/deleteContactMethod.graphql": "a50b",
	"./contact-method/api/getAllContactMethods.graphql": "cfdc",
	"./contact-method/api/updateContactMethod.graphql": "2ab9",
	"./core/api/getAlertQuantity.graphql": "7ebb",
	"./core/api/getCustomersByDay.graphql": "2ca2",
	"./core/api/getCustomersByMonth.graphql": "8ce1",
	"./core/api/getDeliveryStatusCount.graphql": "b4c5",
	"./core/api/getOrdersByDay.graphql": "b5f7",
	"./core/api/getOrdersByMonth.graphql": "c280",
	"./core/api/getPackageCount.graphql": "5d82",
	"./core/api/getSalesTrendGraph.graphql": "b450",
	"./core/api/getTrendingMealCount.graphql": "bf28",
	"./customer/api/addCustomerAllergy.graphql": "8b2f",
	"./customer/api/addCustomerDislike.graphql": "fb60",
	"./customer/api/adminCheckoutCustomerPackage.graphql": "3eb9",
	"./customer/api/adminChooseCustomerMenu.graphql": "25ce",
	"./customer/api/adminCustomerSignUp.graphql": "f360",
	"./customer/api/applyPromoCode.graphql": "283c",
	"./customer/api/birthdayReport.graphql": "fa77",
	"./customer/api/checkSubscriptionEligibility.graphql": "875a",
	"./customer/api/confirmModifiedPackagePayment.graphql": "96af",
	"./customer/api/createAppointment.graphql": "c7cf",
	"./customer/api/createArea.graphql": "fada",
	"./customer/api/createBlock.graphql": "7de8",
	"./customer/api/createDeliverySchedule.graphql": "f500",
	"./customer/api/createGovernorate.graphql": "6784",
	"./customer/api/createHealthInfo.graphql": "a0ab",
	"./customer/api/createShift.graphql": "dee8",
	"./customer/api/createTempCustomerSalesorder.graphql": "86c7",
	"./customer/api/createZone.graphql": "b6fb",
	"./customer/api/customerAgeWiseReport.graphql": "7f2b",
	"./customer/api/customerAnalytics.graphql": "1459",
	"./customer/api/customerGenderWiseReport.graphql": "8f7e",
	"./customer/api/customerSignUp.graphql": "e482",
	"./customer/api/customerTags.graphql": "531b",
	"./customer/api/customers.graphql": "5f99",
	"./customer/api/customizeSubscribedCustomerPackagePayment.graphql": "2f95",
	"./customer/api/deleteArea.graphql": "aed2",
	"./customer/api/deleteBlock.graphql": "34c0",
	"./customer/api/deleteCustomer.graphql": "4ee2",
	"./customer/api/deleteCustomerDislike.graphql": "37a4",
	"./customer/api/deleteDeliverySchedule.graphql": "2392",
	"./customer/api/deleteDietitianAppointment.graphql": "3cae",
	"./customer/api/deleteGovernorate.graphql": "c38d",
	"./customer/api/deleteShift.graphql": "f2ba",
	"./customer/api/deleteZone.graphql": "116f",
	"./customer/api/freezeCustomerMenu1.graphql": "1b01",
	"./customer/api/getAgewiseTrend.graphql": "67ed",
	"./customer/api/getAllActiveDietitianAppoinments.graphql": "95a1",
	"./customer/api/getAllAppoinments.graphql": "e596",
	"./customer/api/getAllAreas.graphql": "313b",
	"./customer/api/getAllBlocks.graphql": "af28",
	"./customer/api/getAllCategoryWiseMenu.graphql": "d222",
	"./customer/api/getAllCustomerBasicInfo.graphql": "6132",
	"./customer/api/getAllCustomerRating.graphql": "734b",
	"./customer/api/getAllDietitianAppointments.graphql": "15ed",
	"./customer/api/getAllDriverShifts.graphql": "6c09",
	"./customer/api/getAllGovernorates.graphql": "bed5",
	"./customer/api/getAllHowFoundAboutAppSources.graphql": "87bd",
	"./customer/api/getAllPhoneVerifications.graphql": "31ed",
	"./customer/api/getAllShifts.graphql": "0d5f",
	"./customer/api/getAllUsers.graphql": "d491",
	"./customer/api/getAllZones.graphql": "baf5",
	"./customer/api/getAreaByRegion.graphql": "a4b0",
	"./customer/api/getBlocksByArea.graphql": "cc7c",
	"./customer/api/getBranchesByGovernorate.graphql": "c3b9",
	"./customer/api/getCustomerById.graphql": "0fc6",
	"./customer/api/getCustomerDetailByCreatedDate.graphql": "4a14",
	"./customer/api/getCustomersTempPackages.graphql": "74c1",
	"./customer/api/getCustomersWithNoMeals.graphql": "ceb7",
	"./customer/api/getDeliveryScheduleByCustomerId.graphql": "e9bc",
	"./customer/api/getDietitianPendingPaymentDetails.graphql": "3356",
	"./customer/api/getGenderwiseTrend.graphql": "1a03",
	"./customer/api/getHealthInfoByCustomerId.graphql": "261b",
	"./customer/api/getInactiveCustomers.graphql": "e91b",
	"./customer/api/getLastReportGeneratedDate.graphql": "2ae1",
	"./customer/api/getShiftsByArea.graphql": "4bda",
	"./customer/api/importCustomers.graphql": "5b7d",
	"./customer/api/pauseCustomerMenu.graphql": "189d",
	"./customer/api/queries/isLocationInServingArea.graphql": "a892",
	"./customer/api/recheckAppointmentPaymentStatus1.graphql": "707d",
	"./customer/api/regenerateAppointmentInvoiceUrl.graphql": "87bf",
	"./customer/api/removeCustomerAllergy.graphql": "330e",
	"./customer/api/resetPassword.graphql": "927d",
	"./customer/api/restoreCustomer.graphql": "4cd8",
	"./customer/api/searchCustomers.graphql": "a6b4",
	"./customer/api/selectByCustomer.graphql": "ba68",
	"./customer/api/unpauseCustomerMenu.graphql": "3e04",
	"./customer/api/updateArea.graphql": "6569",
	"./customer/api/updateBlock.graphql": "2ad3",
	"./customer/api/updateCustomer.graphql": "a44f",
	"./customer/api/updateCustomerSalesorder.graphql": "e8b3",
	"./customer/api/updateDietitianAppointment.graphql": "711a",
	"./customer/api/updateDietitianAppt.graphql": "83d8",
	"./customer/api/updateGovernorate.graphql": "99f5",
	"./customer/api/updateHealthInfo.graphql": "622b",
	"./customer/api/updateHowFoundAboutAppSource.graphql": "ae56",
	"./customer/api/updateShift.graphql": "3d68",
	"./customer/api/updateZone.graphql": "84a3",
	"./customer/api/validateCustomerImport.graphql": "1a22",
	"./customer/components/freeze/api/deleteFreeze.graphql": "bd9b",
	"./customer/components/freeze/api/freezePackages.graphql": "828f",
	"./customer/components/freeze/api/getAllFreeze.graphql": "39f7",
	"./customer/components/freeze/api/getCustomerFreezeDays.graphql": "fd06",
	"./customer/components/freeze/api/removePackageFreeze.graphql": "38c8",
	"./customer/components/freeze/api/updateFreeze.graphql": "0815",
	"./customer/components/salesOrder/api/checkPlanSwitchOnlinePaymentStatus.graphql": "c7f4",
	"./customer/components/salesOrder/api/customerGetAllCelebrities.graphql": "5cf6",
	"./customer/components/salesOrder/api/getDaysLeft.graphql": "5a57",
	"./customer/components/salesOrder/api/getMealSelectionDate.graphql": "abcb",
	"./customer/components/salesOrder/api/getPlanSwitchHistory.graphql": "232c",
	"./customer/components/salesOrder/api/listAdditionalPayments.graphql": "9712",
	"./customer/components/salesOrder/api/planSwitchMarkAsPaid.graphql": "b290",
	"./customer/components/salesOrder/api/previewVariantSwitchPrice.graphql": "ceaa",
	"./customer/components/salesOrder/api/reCalculateEndDate.graphql": "dbe3",
	"./customer/components/salesOrder/api/recheckPaymentStatus.graphql": "927f",
	"./customer/components/salesOrder/api/recheckSalesOrderEditPaymentStatus.graphql": "30fe",
	"./customer/components/salesOrder/api/regenerateInvoiceUrl.graphql": "78ce",
	"./customer/components/salesOrder/api/regenerateSalesOrderInvoiceUrl.graphql": "930a",
	"./customer/components/salesOrder/api/switchCustomerPlan.graphql": "283a",
	"./customer/components/salesOrder/api/transferSubscription.graphql": "28771",
	"./customer/components/salesOrder/api/updateSalesOrderToExpire.graphql": "1928",
	"./delivery/api/excelDeliveryExportReport.graphql": "60bf",
	"./delivery/api/generateDeliveryReport.graphql": "d63c",
	"./delivery/api/getCustomerByCustomerUniqueId.graphql": "6e13",
	"./delivery/api/getDeliveryDetails.graphql": "4890",
	"./delivery/api/getDeliveryDetailsByDate.graphql": "d97a",
	"./delivery/api/getInstantViewDeliveryDetailsByDate.graphql": "9556",
	"./delivery/api/hasMealStickersForShift.graphql": "ddbe",
	"./delivery/api/isAllowToGenerateReport.graphql": "6c65",
	"./dietitian/api/checkDietitianPaymentStatus.graphql": "d2c2",
	"./dietitian/api/createDietitian.graphql": "3ceb",
	"./dietitian/api/deleteDietitian.graphql": "5db5",
	"./dietitian/api/getAllActiveAppoinmentsByDietitian.graphql": "414f",
	"./dietitian/api/getAllAppoinmentsByDietitian.graphql": "5c40",
	"./dietitian/api/getAllDietitians.graphql": "0cf8",
	"./dietitian/api/getDietitianById.graphql": "08de",
	"./dietitian/api/updateDietitian.graphql": "fd2c",
	"./dietitian/dietitian_settings/api/createPlanSuggestion.graphql": "19b5",
	"./dietitian/dietitian_settings/api/createSlotAppointment.graphql": "833f",
	"./dietitian/dietitian_settings/api/getAllSlotAppointments.graphql": "9ec2",
	"./dietitian/dietitian_settings/api/getCustomerSlotAppointment.graphql": "9098",
	"./dietitian/dietitian_settings/api/getDietitanSlots.graphql": "6d97",
	"./dietitian/dietitian_settings/api/getDietitianSlotAppointment.graphql": "1a07",
	"./dietitian/dietitian_settings/api/getDietitianSuggestedPlans.graphql": "6116",
	"./dietitian/dietitian_settings/api/getSlotDetails.graphql": "7500",
	"./dietitian/dietitian_settings/api/removePlanSuggestion.graphql": "5e9c",
	"./dietitian/dietitian_settings/api/updateDietitianSettings.graphql": "a93b",
	"./dietitian/dietitian_settings/api/updateSlotAppointment.graphql": "e9f0",
	"./discount/api/createShopDiscount.graphql": "fdeb",
	"./discount/api/deleteShopDiscount.graphql": "ef2a",
	"./discount/api/getAllDiscounts.graphql": "f72c",
	"./discount/api/getPromoCodeById.graphql": "1174",
	"./discount/api/updateShopDiscount.graphql": "c3b4",
	"./ecommerse/api/assignDriverToOrder.graphql": "2856",
	"./ecommerse/api/checkDriverPendingOrders.graphql": "23c0",
	"./ecommerse/api/checkOrderPaymentStatus.graphql": "ba3c",
	"./ecommerse/api/createProduct.graphql": "5d5a",
	"./ecommerse/api/createProductCategory.graphql": "e881",
	"./ecommerse/api/deleteProduct.graphql": "6ebc",
	"./ecommerse/api/deleteProductCategory.graphql": "74af",
	"./ecommerse/api/getAllProductCategories.graphql": "335f",
	"./ecommerse/api/getAllProducts.graphql": "68c1",
	"./ecommerse/api/getDiscountByItem.graphql": "8b73",
	"./ecommerse/api/getMenuItemByCode.graphql": "5255",
	"./ecommerse/api/getZoneDeliveryCharge.graphql": "289a",
	"./ecommerse/api/listOrders.graphql": "365b",
	"./ecommerse/api/orderDetails.graphql": "0ec5",
	"./ecommerse/api/products.graphql": "2604",
	"./ecommerse/api/updateOrderStatuses.graphql": "ebee",
	"./ecommerse/api/updateProduct.graphql": "3a5f",
	"./ecommerse/api/updateProductCategory.graphql": "455f",
	"./faq/api/createFaq.graphql": "a99e",
	"./faq/api/deleteFaq.graphql": "2aeb",
	"./faq/api/getAllFaqs.graphql": "b027",
	"./faq/api/updateFaq.graphql": "726c",
	"./gateway-charges/api/createPaymentGatewayCharge.graphql": "d1ab",
	"./gateway-charges/api/deleteFaq.graphql": "ea7d",
	"./gateway-charges/api/getPaymentGatewayCharges.graphql": "4aae",
	"./gateway-charges/api/updatePaymentGatewayCharge.graphql": "6a60",
	"./homepage-settings/api/createWebHomePackage.graphql": "43e6",
	"./homepage-settings/api/deleteWebHomePackage.graphql": "b745",
	"./homepage-settings/api/getWebHomePackage.graphql": "aeec",
	"./homepage-settings/api/updateWebHomePackage.graphql": "00c3",
	"./integrations/api/clearFirebasePushCredentials.graphql": "bb8b",
	"./integrations/api/sendTestWhatsAppMessage.graphql": "197a",
	"./integrations/api/testHesabeConnection.graphql": "b3e5",
	"./integrations/api/updateConceptBmsSmsCredentials.graphql": "0a78",
	"./integrations/api/updateFccSmsCredentials.graphql": "7ca9",
	"./integrations/api/updateFirebasePushAndroidChannelId.graphql": "42d0",
	"./integrations/api/updateFirebasePushCredentials.graphql": "e389",
	"./integrations/api/updateGallaboxCredentials.graphql": "a885",
	"./integrations/api/updateHesabePaymentCredentials.graphql": "59e1",
	"./integrations/api/updateKwtsmsSmsCredentials.graphql": "437f",
	"./integrations/api/updateMsg91SmsCredentials.graphql": "2f10",
	"./integrations/api/updateMyFatoorahPaymentCredentials.graphql": "c4b4",
	"./integrations/api/updateOoredooSmsCredentials.graphql": "c0df",
	"./integrations/api/updatePaymentGatewaySelection.graphql": "08a7",
	"./integrations/api/updateRazorpayPaymentCredentials.graphql": "0768",
	"./integrations/api/updateSkipCashPaymentCredentials.graphql": "e067",
	"./integrations/api/updateSmsEasyCredentials.graphql": "b391",
	"./integrations/api/updateSmsGatewaySelection.graphql": "2f14",
	"./integrations/api/updateTapPaymentCredentials.graphql": "7cf2",
	"./location/api/createCustomLocation.graphql": "c204",
	"./location/api/deleteCustomLocation.graphql": "824f",
	"./location/api/getLocationAncestry.graphql": "575a",
	"./location/api/getLocationBoundary.graphql": "3048",
	"./location/api/getLocationCountryInfo.graphql": "f8e1",
	"./location/api/getLocationTree.graphql": "ac65",
	"./location/api/searchLocations.graphql": "daf9",
	"./location/api/syncCountryLocations.graphql": "a45b",
	"./location/api/updateLocationDelivery.graphql": "8752",
	"./managers/api/createManager.graphql": "7d44",
	"./managers/api/deleteManager.graphql": "8413",
	"./managers/api/getAllManagers.graphql": "0545",
	"./managers/api/getManagerById.graphql": "30af",
	"./managers/api/updateManager.graphql": "a71e",
	"./menu-packages/api/checkCustomersBeforeMealDeactivate.graphql": "17eb",
	"./menu-packages/api/createCategory.graphql": "2a9d",
	"./menu-packages/api/createCategoryType.graphql": "3288",
	"./menu-packages/api/createMenuItem.graphql": "0c40",
	"./menu-packages/api/createPackages.graphql": "d21a",
	"./menu-packages/api/deleteCategory.graphql": "d770",
	"./menu-packages/api/deleteMenuItem.graphql": "d5d5",
	"./menu-packages/api/deletePackages.graphql": "37cd",
	"./menu-packages/api/duplicateMenuItem.graphql": "d6f1",
	"./menu-packages/api/duplicatePackages.graphql": "79be",
	"./menu-packages/api/getAllAppIcons.graphql": "3a5c",
	"./menu-packages/api/getAllCUstomerTags.graphql": "7537",
	"./menu-packages/api/getAllCategories.graphql": "c425",
	"./menu-packages/api/getAllCategoryTypes.graphql": "b973",
	"./menu-packages/api/getAllCustomersInCurrentPackage.graphql": "4392",
	"./menu-packages/api/getAllCustomersUsingMealByDate.graphql": "307d",
	"./menu-packages/api/getAllMealsTags.graphql": "a765",
	"./menu-packages/api/getAllMenuItems.graphql": "b36a",
	"./menu-packages/api/getAllPackages.graphql": "6dce",
	"./menu-packages/api/getAllPackagesReport.graphql": "04d8",
	"./menu-packages/api/getAllPackagesWithChoice.graphql": "1774",
	"./menu-packages/api/getMenuItemById.graphql": "b2c0",
	"./menu-packages/api/getMenuItemsForExport.graphql": "a57f",
	"./menu-packages/api/getNewMealCode.graphql": "2a33",
	"./menu-packages/api/getPackageAllowedWeekDays.graphql": "6bec",
	"./menu-packages/api/getPackageById.graphql": "454b",
	"./menu-packages/api/importMeals.graphql": "03ef",
	"./menu-packages/api/importPackages.graphql": "2779",
	"./menu-packages/api/updateCategory.graphql": "0f69",
	"./menu-packages/api/updateCategoryType.graphql": "4f44",
	"./menu-packages/api/updateCustomerTag.graphql": "6547c",
	"./menu-packages/api/updateMealsTag.graphql": "fac4",
	"./menu-packages/api/updateMenuItem.graphql": "a8927",
	"./menu-packages/api/updatePackages.graphql": "5210",
	"./menu-packages/api/validateMealImport.graphql": "3c40",
	"./menu-packages/api/validatePackagesImport.graphql": "dd80",
	"./menu-packages/diet-plan/api/createDietPlan.graphql": "dead",
	"./menu-packages/diet-plan/api/deleteDietPlan.graphql": "59b0",
	"./menu-packages/diet-plan/api/getAllDietPlans.graphql": "8ffb",
	"./menu-packages/diet-plan/api/updateDietPlan.graphql": "09a4",
	"./menu-packages/meal-ratings/api/getRatingByMealId.graphql": "26a3",
	"./notifications/api/createNotification.graphql": "6286",
	"./notifications/api/getAllNotifications.graphql": "c0f2",
	"./offer/api/createOffer.graphql": "11a4",
	"./offer/api/deleteOffer.graphql": "37f7",
	"./offer/api/getAllOffers.graphql": "269f",
	"./offer/api/updateOffer.graphql": "a925e",
	"./orders/api/getAdminUsers.graphql": "0dce",
	"./orders/api/getAllInactiveSubscribedPackagesWithDate.graphql": "acd0",
	"./orders/api/getAllSubscribedPackages.graphql": "f0f7",
	"./orders/api/getAllSubscribedPackagesWithDate.graphql": "1d7a",
	"./orders/api/getInactiveSubscribePackageCount.graphql": "44c9",
	"./orders/api/getIngredientDetailsByDate.graphql": "7873",
	"./orders/api/getOrderMealDetailsByDate.graphql": "4e8a",
	"./orders/api/importSalesOrders.graphql": "9f18",
	"./orders/api/subscribedPackageEndDateReminder.graphql": "a290",
	"./orders/api/validateSalesOrderImport.graphql": "0e51",
	"./pdf-templates/api/updatePdfTemplateSettings.graphql": "b325",
	"./permission/api/createUserRole.graphql": "cfe0",
	"./permission/api/deleteUserRoleById.graphql": "9678",
	"./permission/api/getAllUserRole.graphql": "1d79",
	"./permission/api/getUserRolePermission.graphql": "f20c",
	"./permission/api/updateUserRolePermission.graphql": "a75b",
	"./plan-switch/api/createPlanSwitch.graphql": "e1a0",
	"./plan-switch/api/deletePlanSwitch.graphql": "6d6f",
	"./plan-switch/api/getAllPlanSwitches.graphql": "ab95",
	"./plan-switch/api/groupPlanSwitch.graphql": "7cd5",
	"./plan-switch/api/swapPlanSwitch.graphql": "7247",
	"./plan-switch/api/switchAllCustomerPlans.graphql": "5056",
	"./promotion/api/createPromoCode.graphql": "98cb",
	"./promotion/api/deletePromoCode.graphql": "d6f9",
	"./promotion/api/getAllPromoCodes.graphql": "ea9c",
	"./promotion/api/getPromoCodeById.graphql": "1bc7",
	"./promotion/api/importPromoCodes.graphql": "8628",
	"./promotion/api/updatePromoCode.graphql": "0f1d",
	"./promotion/api/validatePromoCodeImport.graphql": "7ccb",
	"./referral-transactions/api/getAllReferralTransactions.graphql": "de81",
	"./referral-transactions/api/getReferralStatistics.graphql": "aeba",
	"./region/api/createRegion.graphql": "ac88",
	"./region/api/deleteRegion.graphql": "7d09",
	"./region/api/getAllRegions.graphql": "dd51",
	"./region/api/updateRegion.graphql": "513a",
	"./reports/api/adminMarkDeliveriesDelivered.graphql": "e492",
	"./reports/api/createDriver.graphql": "925f",
	"./reports/api/deleteDriver.graphql": "d076",
	"./reports/api/excelReports.graphql": "912e",
	"./reports/api/getAllContactUs.graphql": "3bec",
	"./reports/api/getAllDrivers.graphql": "0d48",
	"./reports/api/getAllPlanTransferHistories.graphql": "a4ec",
	"./reports/api/getCustomerIntelligence.graphql": "a871",
	"./reports/api/getCustomerMonthlySalesReport.graphql": "4d3d",
	"./reports/api/getDeliveryIntelligence.graphql": "b054",
	"./reports/api/getDeliveryIntelligenceVolume.graphql": "c200",
	"./reports/api/getDietitianIntelligence.graphql": "8282",
	"./reports/api/getDriverIntelligence.graphql": "12ce",
	"./reports/api/getDriverReport.graphql": "3d3a",
	"./reports/api/getExecutiveOverview.graphql": "324a",
	"./reports/api/getIngredientRequirementReport.graphql": "965f",
	"./reports/api/getInventoryIntelligence.graphql": "446e",
	"./reports/api/getMarketingIntelligence.graphql": "064d",
	"./reports/api/getMealMenuIntelligence.graphql": "6b3a",
	"./reports/api/getMealOrderCount.graphql": "1a27",
	"./reports/api/getOrderProductionReport.graphql": "b3c5",
	"./reports/api/getPackagePerformance.graphql": "7dfa",
	"./reports/api/getPausedMealsDetailsByDate.graphql": "9d12",
	"./reports/api/getProductionIntelligence.graphql": "6eac",
	"./reports/api/getPromoPerformance.graphql": "0e97",
	"./reports/api/getPromocodeReport.graphql": "102f",
	"./reports/api/getReportStatus.graphql": "48f8",
	"./reports/api/getSalesIntelligence.graphql": "a6ba",
	"./reports/api/getSubscriptionIntelligence.graphql": "50c8",
	"./reports/api/listAllAdditionalPayments.graphql": "de14",
	"./reports/api/updateDriver.graphql": "2df8",
	"./sales/api/getDetailedSalesReport.graphql": "aea3",
	"./sales/api/getSalesReport.graphql": "aaa5",
	"./schedule-notification/api/deleteScheduledNotification.graphql": "95c8",
	"./schedule-notification/api/getAllScheduleNotification.graphql": "357c",
	"./schedule-notification/api/scheduleNotification.graphql": "fa32",
	"./set-menu/api/generateSetMenuReports.graphql": "0df0",
	"./set-menu/api/getSetMenuCustomerDeliveryList.graphql": "db63",
	"./set-menu/api/getSetMenuOrderDeliveriesByMasterId.graphql": "2d41",
	"./set-menu/api/getSetMenuReportMasterByReportId.graphql": "f9bd",
	"./set-menu/api/getSetMenuReports.graphql": "c1e1",
	"./set-menu/api/getSetmenuLastReportGeneratedDate.graphql": "4983",
	"./set-menu/api/getSetmenuMealList.graphql": "365f",
	"./set-menu/api/removeSetmenuReport.graphql": "8936",
	"./settings/api/confirmPrivacyPolicy.graphql": "d8fe",
	"./settings/api/createFlashOffer.graphql": "1016",
	"./settings/api/createPolicy.graphql": "a0b1",
	"./settings/api/createTutorial.graphql": "5dd4",
	"./settings/api/deleteFlashOffer.graphql": "4fb4",
	"./settings/api/deletePortion.graphql": "06a7",
	"./settings/api/getActivePortions.graphql": "03e2",
	"./settings/api/getAppConfigurations.graphql": "536d",
	"./settings/api/getFlashOffers.graphql": "2df86",
	"./settings/api/getOnboardingStatus.graphql": "3746",
	"./settings/api/getPolicy.graphql": "012c",
	"./settings/api/getPortions.graphql": "0259",
	"./settings/api/getPrivacyPolicyAdmin.graphql": "1d83",
	"./settings/api/getPrivacyPolicyTemplate.graphql": "6bdf",
	"./settings/api/getPushNotification.graphql": "3011",
	"./settings/api/getSystemAppearance.graphql": "82e0",
	"./settings/api/getTutorial.graphql": "7f6f",
	"./settings/api/getUser.graphql": "eb15",
	"./settings/api/isPortioningEnabled.graphql": "8cda",
	"./settings/api/resetMobileAppConfig.graphql": "a98b",
	"./settings/api/savePrivacyPolicy.graphql": "aa1c",
	"./settings/api/togglePortionStatus.graphql": "613d",
	"./settings/api/updateConfigurations.graphql": "8abf",
	"./settings/api/updateFlashOffer.graphql": "1822",
	"./settings/api/updatePassword.graphql": "83c1",
	"./settings/api/updatePolicy.graphql": "93bd",
	"./settings/api/updatePushNotification.graphql": "34e6",
	"./settings/api/updateSystemAppearance.graphql": "6211",
	"./settings/api/updateTutorial.graphql": "7833",
	"./settings/api/updateUser.graphql": "d67b",
	"./settings/api/uploadImage.graphql": "ff81",
	"./settings/api/upsertBrandSetting.graphql": "9d7c",
	"./settings/api/upsertMobileAppConfig.graphql": "91bc",
	"./settings/api/upsertPortion.graphql": "660a",
	"./settings/api/viewBrandSetting.graphql": "907f",
	"./settings/api/viewMobileAppConfig.graphql": "bf14",
	"./stock/api/adjustStock.graphql": "8499",
	"./stock/api/createIngredient.graphql": "7f75",
	"./stock/api/createPurchase.graphql": "e180",
	"./stock/api/createUnit.graphql": "69ba",
	"./stock/api/createVendor.graphql": "4d6d",
	"./stock/api/deleteIngredient copy.graphql": "897d",
	"./stock/api/deleteIngredient.graphql": "94a0",
	"./stock/api/deletePurcahse.graphql": "bd57",
	"./stock/api/deleteUnit.graphql": "a214",
	"./stock/api/deleteVendor.graphql": "204c",
	"./stock/api/editVendor.graphql": "37f1",
	"./stock/api/getAllBrands.graphql": "9b55",
	"./stock/api/getAllCurrentStocks.graphql": "7a39",
	"./stock/api/getAllDislikableIngredients.graphql": "3f03",
	"./stock/api/getAllIngredients.graphql": "d043",
	"./stock/api/getAllMealIngredients.graphql": "1169",
	"./stock/api/getAllPurchases.graphql": "ee82",
	"./stock/api/getAllStockAdjust.graphql": "4eed",
	"./stock/api/getAllStocks.graphql": "88b2",
	"./stock/api/getAllUnits.graphql": "69d8",
	"./stock/api/getIngredientCurrentStock.graphql": "cc24",
	"./stock/api/getNewIngredientCode.graphql": "db9c",
	"./stock/api/importIngredients.graphql": "3a81",
	"./stock/api/listAllVendors.graphql": "4dcf",
	"./stock/api/monthlyPurchase.graphql": "52f8",
	"./stock/api/monthlyUtilization.graphql": "64d8",
	"./stock/api/updateIngredient.graphql": "d7d2",
	"./stock/api/updatePurchase.graphql": "0b1b",
	"./stock/api/updateUnit.graphql": "1480",
	"./stock/api/validateIngredientImport.graphql": "61d3",
	"./stock/brand/api/createBrand.graphql": "885b",
	"./stock/brand/api/deleteBrand.graphql": "1a47",
	"./stock/brand/api/editBrand.graphql": "96c7",
	"./stock/brand/api/listAllBrands.graphql": "bd35",
	"./universal-pause/api/createUniversalPause.graphql": "b560",
	"./universal-pause/api/deleteUniversalPause.graphql": "9813",
	"./universal-pause/api/getAllUniversalPause.graphql": "3cfe",
	"./user/api/getCustomerSubscriptionCount.graphql": "ee23",
	"./user/api/getDashboardData.graphql": "ce1e",
	"./user/api/getDashboardExtendedData.graphql": "2092",
	"./user/api/getTodayCustomerBirthdays.graphql": "3968",
	"./user/api/signin.graphql": "05b3",
	"./user/api/updateUserLanguage.graphql": "d0aa",
	"./user/api/user_fragment.graphql": "1d17",
	"./whatsapp-settings/api/clearFailedSendLogs.graphql": "1dcf",
	"./whatsapp-settings/api/createGallaboxTemplate.graphql": "caad7",
	"./whatsapp-settings/api/createManualTemplateMapping.graphql": "f0a1",
	"./whatsapp-settings/api/deleteFailedSendLog.graphql": "71ed",
	"./whatsapp-settings/api/deleteGallaboxTemplate.graphql": "255c",
	"./whatsapp-settings/api/deleteManualTemplateMapping.graphql": "0581",
	"./whatsapp-settings/api/getAllGallaboxTemplates.graphql": "0474",
	"./whatsapp-settings/api/getAllManualTemplateMappings.graphql": "d98b",
	"./whatsapp-settings/api/getAllTemplatesFromGallabox.graphql": "df24",
	"./whatsapp-settings/api/getCustomersBySubscriptionRange.graphql": "ffe5",
	"./whatsapp-settings/api/getFailedSendLogs.graphql": "3806",
	"./whatsapp-settings/api/getGallaboxChannels.graphql": "8d30",
	"./whatsapp-settings/api/getGallaboxSettings.graphql": "c3ff",
	"./whatsapp-settings/api/sendTemplateByMultipleRanges.graphql": "4bd3",
	"./whatsapp-settings/api/sendTemplateByRange.graphql": "6ced",
	"./whatsapp-settings/api/sendTemplateToSelectedCustomers.graphql": "e2a1",
	"./whatsapp-settings/api/updateGallaboxSettings.graphql": "0f2b",
	"./whatsapp-settings/api/updateGallaboxTemplate.graphql": "5048",
	"./whatsapp-settings/api/updateManualTemplateMapping.graphql": "4b6d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dca3";